<template>
  <div>
    <list
      row-key="PurchaseArrivalId"
      ref="list"
      unit="应付总账"
      :page="false"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      :get-data-func="api.getPurchaseIdea"
      @check-change="checkChange"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <template>
          <el-form-item label="仓库名称">
            <el-select
              v-model="params.WarehouseId"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in wareList"
                :key="item.WarehouseId"
                :label="item.WarehouseName"
                :value="item.WarehouseId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期">
            <el-date-picker
              v-model="params.beginDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择开始时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker
              v-model="params.endDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择结束时间"
            ></el-date-picker>
          </el-form-item>
        </template>
      </template>
      <template slot="table">
        <el-table-column label="供应商" prop="TradeUnitName" min-width="150px">
          <template slot-scope="{ row }">
            <!--
            <supplier  @restaurants="setSupplier($event, row)" :state="row.TradeUnitName" v-show="row.isShow" />
            <span v-show="!row.isShow">{{row.TradeUnitName}}</span>
            -->
            <span>{{ row.TradeUnitName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品" prop="GoodsName" />
        <el-table-column label="规格型号" prop="Model" />
        <el-table-column label="单价" prop="Price" />
        <el-table-column label="销售数量" prop="Quantity" />
        <el-table-column label="单位" prop="UnitName" />
        <el-table-column label="现存量" prop="ExistQuantity" />
        <!--<el-table-column label="建议采购数量" prop="IdeaQuantity"/>-->
        <el-table-column label="建议采购数量" prop="Quantity" />
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import supplier from "@/components/common/supplier/supplier";

export default {
  mixins: [listMixin],
  components: { list, supplier },
  data() {
    return {
      api: require("@/api/purchase/order").default,
      wareApi: require("@/api/ba/warehouse").default,
      params: {
        WarehouseId: null,
        beginDate: "",
        endDate: "",
      },
      wareList: [],
      isMB: this.$store.state.isMB,
      SelectcheckBoxList: [], // 存放选中的多选框项目
      tempRows: [],
    };
  },
  mounted() {
    this.cycleChange("昨天");
    this.wareApi.list({ PageIndex: 1, PageSize: 100 }).then((res) => {
      this.wareList = res.Data;
      // sessionStorage.setItem("ware", JSON.stringify(res.Data));
    });
  },
  methods: {
    // 多选框选中的列表项
    checkChange(row) {
      this.SelectcheckBoxList = row;
      this.$emit("check-change", this.SelectcheckBoxList); 
      // let status = this.tempRows.length < row.length ? 0 : -1; // 0 为添加， -1 为减少
      // if (status === -1) {
      //   let tempRowsGoodIds = this.tempRows.map((value) => {
      //     console.log(JSON.stringify(value));
      //     return JSON.stringify(value);
      //   });
      //   console.log("this.tempRows", this.tempRows);
      //   console.log("tempRowsGoodIds", tempRowsGoodIds);
      //   let rowGoodIds = row.map((value) => {
      //     return JSON.stringify(value);
      //   });
      //   console.log("row", row);
      //   console.log("rowGoodIds", rowGoodIds);
      //   let _goodIds = tempRowsGoodIds.filter((v) => {
      //     return rowGoodIds.indexOf(v) === -1;
      //   });
      //   console.log("_goodId", _goodIds);
      //   console.log("tempRowsGoodIds", tempRowsGoodIds);

      //   let _goodIdIndexs = _goodIds.map((value, index) => {
      //     return tempRowsGoodIds.indexOf(_goodIds[index]);
      //   });
      //   console.log("_goodIdIndex", _goodIdIndexs);
      //   if (_goodIdIndexs.length > 1) {
      //     _goodIdIndexs.forEach((value, index) => {
      //       delete this.tempRows[index].isShow;
      //       console.log("this.tempRows1111", this.tempRows);
      //     });
      //   } else {
      //     delete this.tempRows[_goodIdIndexs[0]].isShow;
      //     console.log("this.tempRows", this.tempRows);
      //   }

      //   this.tempRows = row;
      // } else {
      //   row.forEach((value) => {
      //     value.isShow = true;
      //     this.tempRows.push(value);
      //   });
      //   this.tempRows = row;
      // }
    },

    // 供应商选择
    setSupplier(e, row) {
      let oldTradeUnitName = row.TradeUnitName;
      let oldTradeUnitId = row.TradeUnitId;
      row.TradeUnitId = e.TradeUnitId;
      row.TradeUnitName = e.TradeUnitName;

      this.$emit("setSupplier", {
        row,
        oldTradeUnitName,
        oldTradeUnitId,
        tradeUnitId: e.TradeUnitId,
        tradeUnitName: e.TradeUnitName,
      });
    },

    //设置默认日期
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }
      this.params.beginDate = start;
      this.params.endDate = end;
      this.query(this.params);
    },
  },
};
</script>